angular.module("avant.customer_applications.controllers").controller "NeuroIdMixinCtrl", [
  "$scope", "$window", "$cookies", "$q", "$timeout", "CustomerApplicationService", "HeapService", "TrackPage", "TrackUtils"
  ($scope, $window, $cookies, $q, $timeout, CustomerApplicationService, HeapService, TrackPage, TrackUtils) ->

    NEURO_ID_COOKIE_NAME = "neuro-id" # NeuroID 2.x only
    NEURO_ID_COOKIE_EXPIRES_AT = 30 # NeuroID 2.x only
    LOAN_AMOUNT_SLIDER_NAME = "loan_amount_slider" # NeuroID 3.x only
    SUBMISSION_TIMEOUT = 200 # NeuroID 3.x only

    # If track-angular is included and tracking attributes are present in the
    # HTML, neuroIdTrackingPage must be defined or track-angular will error out
    # and break Angular.
    #
    # If trackingConfiguredForPage() returns true and trackingEnabledOnPage()
    # returns false, the TrackPage object will be created but no API calls will
    # be made.
    trackingConfiguredForPage = () ->
      $scope.config?.version_config_data?.neuro_id?.enabled &&
      $scope.page in $scope.config.version_config_data.neuro_id.pages_to_track

    trackingEnabledOnPage = () ->
      trackingConfiguredForPage() &&
      # The following line will need to change when NeuroID 2.x is removed
      $scope.config.neuro_id_api_key? &&
      $scope.is_customer_request

    isFinalPageToTrack = () ->
      $scope.page == $scope.config.version_config_data.neuro_id.final_page_to_track

    shouldSubmitMetadataOnThisPage = () ->
      trackingEnabledOnPage() &&
      $scope.page == $scope.config.version_config_data.neuro_id.page_to_submit_metadata

    # The following two functions are adapted from the code provided by NeuroID.
    # Calling document.cookie directly makes them convoluted and not very
    # maintainable, but this cookie needs an expiration date, and Angular's
    # $cookieStore does not support this in versions prior to 1.4.

    # These two functions are used by NeuroID 2.x only
    getNeuroIDCookie = () ->
      decodedCookie = decodeURIComponent($window.document.cookie)
      ca = decodedCookie.split(';')
      i = 0
      while i < ca.length
        c = ca[i]
        while c.charAt(0) == ' '
          c = c.substring(1)
        if c.indexOf(NEURO_ID_COOKIE_NAME) == 0
          # Return the session ID if it is already set
          return c.substring(NEURO_ID_COOKIE_NAME.length + 1, c.length)
        i++
      # Creates new session ID if no stored session ID is present
      neuro_id_session_id = TrackUtils.uuid()
      setNeuroIdCookie(neuro_id_session_id) if trackingEnabledOnPage()
      neuro_id_session_id

    setNeuroIdCookie = (neuro_id_session_id) ->
      d = new Date
      d.setTime(d.getTime() + NEURO_ID_COOKIE_EXPIRES_AT * 24 * 60 * 60 * 1000)
      expires = 'expires=' + d.toUTCString()
      # The NeuroID example code explicitly specifies the domain, but I'm not
      # sure of the reason for this. Left it out here so that it would work
      # correctly in dev and integration environments.
      $window.document.cookie = "#{NEURO_ID_COOKIE_NAME}=#{neuro_id_session_id};#{expires};path=/;"
      HeapService.track("neuro_id:cookie:set")
      CustomerApplicationService.setNeuroIdSessionId(neuro_id_session_id)

    # NeuroID 2.x only; this is handled on NeuroID's side under 3.x
    neuroIdConfig =
      if trackingConfiguredForPage()
        # Key must be non-null; otherwise initializing the page will raise an error
        key: $scope.config.neuro_id_api_key || "no_api_key_set"
        internalId: getNeuroIDCookie()
        sensitiveCapture: true
        questionOptions:
          # The correspondence between these question IDs and page elements is
          # defined in Avant's NeuroID documentation
          ques_1eQzLpeYXVeIFeeC: type: 'TextQuestion'
          ques_1eQzLp7ykdkunAR9: type: 'TextQuestion'
          ques_1eQzLppFGfS87u6u: type: 'TextQuestion'
          ques_1eQzLp31B0BjKpFJ: type: 'TextQuestion'
          ques_1eQzLp2aqkBhwfaH: type: 'TextQuestion'
          ques_1eQzLpNNUTPMNbJY: type: 'SelectQuestion'
          ques_1eQzLpQBqU8DkZ60: type: 'TextQuestion'
          ques_1eQzLpX0Q3vdRzWh: type: 'RegionQuestion'
          ques_1eQzLp6eZBP4dsM7: type: 'MultipleChoiceQuestion'
          ques_1eQzLpI04GruF5mb: type: 'MultipleChoiceQuestion'
          ques_1eQzLpSMShfuogeg: type: 'TextQuestion'
          ques_1eQzLp8VfsW2rPW4: type: 'SelectQuestion'
          ques_1eQzLpZWcigAz4y2: type: 'SelectQuestion'
          ques_1eQzLpQoWAqThAdO: type: 'SelectQuestion'
          ques_1eQzLpNq7JhX3NU1: type: 'SelectQuestion'
          ques_1eQzLpDf4bdFeGp9: type: 'SelectQuestion'
          ques_1eQzLpl9IMtLyHhj: type: 'TextQuestion'
          ques_1eQzLpB7qDs82TV9: type: 'TextQuestion'
          ques_1eQzLpcIitl1tZUB: type: 'TextQuestion'
          ques_1eQzLpBiBvab72Oy: type: 'TextQuestion'
          ques_1eQzLpRJeqoJ9eMh: type: 'TextQuestion'
          ques_1eQzLpCoE1MGFxPM: type: 'RegionQuestion'
          ques_1eQzLpAU0mEAhWSd: type: 'SelectQuestion'
          ques_1eQzLpOF6IIk5qGn: type: 'TextQuestion'
          ques_1eQzLpajdqwmfkde: type: 'SelectQuestion'
          ques_1eQzLplshKB2oFur: type: 'TextQuestion'
          ques_1eQzLpVOfsVLVHYE: type: 'SelectQuestion'
          ques_1eQzLp2JEq3KhwZq: type: 'TextQuestion'
          ques_1eQzLpR7EGHotYCW: type: 'RegionQuestion'
          ques_1eQzLphwHOF1kecB: type: 'MultipleChoiceQuestion'
          ques_1eQzLpjgzDPKo3ML: type: 'RegionQuestion'
          ques_1eQzLp2JF2AFyqMs: type: 'RegionQuestion'
          ques_1eQzLpSI6ft2Poqr: type: 'RegionQuestion'
          ques_1eQzLpczmsq0RJS6: type: 'RegionQuestion'
          ques_1eQzLp5C5pO6a1gX: type: 'RegionQuestion'
          ques_1eQzLpeo5pF2rH99: type: 'RegionQuestion'
          ques_1eQzFLoDHTAqTORc: type: 'RegionQuestion'
          ques_1eQzLpFvnfrPErpW: type: 'RegionQuestion'
          ques_1eQzLp3adpIpaSIA: type: 'SliderQuestion'
          ques_1eQzLpNVgHHFGF1s: type: 'RegionQuestion'
          ques_1eQzLpI6T2Lw0kSw: type: 'MultipleChoiceQuestion'
          ques_1eQzLpHmzdR5u5YK: type: 'RegionQuestion'
          ques_1eQzLpSY3FmdcfQl: type: 'RegionQuestion'
          ques_1eQzLpwJsSZZIbAU: type: 'RegionQuestion'
          ques_1eQzLpDagrYFf7Zc: type: 'RegionQuestion'
          ques_1eQzLpEisXexaPrX: type: 'RegionQuestion'
          ques_1eQzLp5faVwgAOxI: type: 'RegionQuestion'
          ques_1eQzLpfwNMNMVIrr: type: 'RegionQuestion'
          ques_1eQzLpRAC2G3EnEF: type: 'RegionQuestion'
          ques_1eQzLpyJAWtCKXlA: type: 'RegionQuestion'
          ques_1eQzLpg5qgrYVUG9: type: 'RegionQuestion'
          ques_1eQzLpAebs3GHCph: type: 'RegionQuestion'
          ques_1eQzLpXSKd7Y6vW9: type: 'RegionQuestion'
          ques_1eQzLpbFRRtTVmpq: type: 'RegionQuestion'
          ques_1eQzLp94qLoeEjMo: type: 'RegionQuestion'
          ques_1eQzLpxxHhRP5gKO: type: 'RegionQuestion'
          ques_1eQzLpi24zXNt0TS: type: 'MultipleChoiceQuestion'
          ques_1eQzLpeg5mZbXKs9: type: 'RegionQuestion'
          ques_1eQzLp5GfNCI6ctu: type: 'RegionQuestion'
          ques_1eQzLpe2kMuwwC0v: type: 'RegionQuestion'
          ques_1eQzLp74nFG5gYgw: type: 'RegionQuestion'
          ques_1eQzLpJYUcEW756R: type: 'TextQuestion'
          ques_1eQzLpyccTnmdrcr: type: 'TextQuestion'
          ques_1eQzLpOTQh7m945f: type: 'TextQuestion'
          ques_1eQzLpjIvJCY8ehr: type: 'RegionQuestion'
          ques_1eQzLpqlIIswJPH8: type: 'MultipleChoiceQuestion'
          ques_1eQzLpQUI2AiAlg5: type: 'TextQuestion'
          ques_1eQzLpRFZGUqwbZY: type: 'TextQuestion'
          ques_1eQzLpqFCaKe66yd: type: 'TextQuestion'
          ques_1eQzLps64jvtzjN3: type: 'RegionQuestion'
          ques_1eQzLpoqfWsBki5Q: type: 'TextQuestion'
          ques_1eQzLpv5h4UFCrRI: type: 'SelectQuestion'
          ques_1eQzLpSermjDjkZJ: type: 'SelectQuestion'
          ques_1eQzFLkcF5QmFQNn: type: 'TextQuestion'
          ques_1eQzLpyu9jlXcBJg: type: 'TextQuestion'
          ques_1eQzLpQV3Hj9PlTw: type: 'TextQuestion'
          ques_1eQzLprC4bxont63: type: 'TextQuestion'
          ques_1eQzLp8HAmxvJuSn: type: 'SelectQuestion'
          ques_1eQzLpU3Xftajt3k: type: 'TextQuestion'
          ques_1eQzLpCRNtebCsS5: type: 'TextQuestion'
          ques_1eQzLpdPBIk0r73y: type: 'TextQuestion'
          ques_1eQzLpudumMgi8Pv: type: 'SelectQuestion'
          ques_1eQzLpSbjXGoCUDZ: type: 'SelectQuestion'
          ques_1eQzLph7EIPSjqB1: type: 'SelectQuestion'
          ques_1eQzLpy0qfaFaomB: type: 'SelectQuestion'
          ques_1eQzLp53B0Qtic2u: type: 'TextQuestion'
          ques_1eQzLplTq3p02O0S: type: 'RegionQuestion'
          ques_1eQzLpXgmzmaXmBl: type: 'RegionQuestion'
          ques_1eQzFLMpIX3X26GF: type: 'SelectQuestion'
      else
        null

    # Currently not being used, because of technical issues that NeuroID is
    # investigating
    $scope.loanOptionTooltipNeuroIdQuestions = [
      "ques_1eQzLpHmzdR5u5YK",
      "ques_1eQzLpSY3FmdcfQl",
      "ques_1eQzLpwJsSZZIbAU",
      "ques_1eQzLpDagrYFf7Zc"
    ]

    # NeuroID 2.x only
    neuroIdOfferSlider = null

    # The following two variables are read by track-angular (NeuroID 2.x only)

    # The first argument to the TrackPage constructor is a page ID. It's
    # arbitrary, but must be unique for each page.
    $scope.neuroIdTrackingPage =
      if trackingConfiguredForPage()
        new TrackPage($scope.page, neuroIdConfig)
      else
        null

    $scope.startNeuroIdTracking = trackingEnabledOnPage()

    # Unlike other fields, the slider has to be tracked manually.
    $scope.registerNeuroIdSliderTracking = () ->
      minValue = $scope.product.minimum_requestable_amount
      maxValue = $scope.product.maximum_requestable_amount
      # For NeuroID 2.x
      neuroIdOfferSlider = $scope.neuroIdTrackingPage.registerQuestion(
        'SliderQuestion',
        'ques_1eQzLp3adpIpaSIA',
        {
          value: $scope.product.requested_amount,
          minValue: minValue,
          maxValue: maxValue
        }
      )
      neuroIdOfferSlider.startTracking()
      # For NeuroID 3.x
      $window.nid?("sliderSetMin", LOAN_AMOUNT_SLIDER_NAME, minValue)
      $window.nid?("sliderSetMax", LOAN_AMOUNT_SLIDER_NAME, maxValue)

    $scope.$on "requested_amount_changed", (event, data) ->
      # For NeuroID 2.x
      neuroIdOfferSlider.events.change(data) if neuroIdOfferSlider
      # For NeuroID 3.x
      $window.nid?("sliderChange", LOAN_AMOUNT_SLIDER_NAME, data)

    presentNeuroIdCustomAttributes = (data) ->
      data["has_seen_#{$scope.page}"] = true # Requested by NeuroID
      data["avant_customer_id"] = $scope.customer.uuid
      # The object must consist only of key-value pairs, and the values must
      # be string, numeric, or null. This code casts every value to a string;
      # we're not currently sending anything that could be null or numeric.
      Object.entries(data).forEach((key_value_pair) ->
        data[key_value_pair[0]] = String(key_value_pair[1])
      )
      data

    $scope.submitNeuroIdTrackingDataIfEnabled = () ->
      deferred = $q.defer()
      if trackingEnabledOnPage()
        # Note that even if this is called with 'true' as an argument, it is
        # still possible to submit more tracking data for this application.
        # (This is relevant if page submission fails on the last step.)

        # Submit using NeuroID 2.x
        $scope.neuroIdTrackingPage.submitPage(isFinalPageToTrack()).then(
          # Submit using NeuroID 3.x
          submitDataWithTimeout(deferred)
        ).catch(
          # Resolve the promise regardless of success. We don't want to prevent
          # submission if the NeuroID API call fails, since the customer can't
          # do anything to correct this.
          () -> deferred.resolve()
        )
      else
        deferred.resolve()
      deferred.promise

    submitDataWithTimeout = (deferred) ->
      # This method submits data using NeuroID 3.x only. NeuroID suggested this
      # implementation, so that we won't delay page submission too much if
      # their API is unreachable for some reason.
      $window.nid?("sendData", () => deferred.resolve())
      $timeout((() => deferred.resolve()), SUBMISSION_TIMEOUT)

    # For NeuroID 3.x
    submitMetadata = (data) ->
      Object.entries(data).forEach((key_value_pair) ->
        # Anything with a boolean value should be set as a tag under NeuroID 3,
        # and only if the value is true. This logic can be simplified/refactored
        # when NeuroID 2 is removed
        if (key_value_pair[1] == true)
          $window.nid?("tag", key_value_pair[0])
        else if key_value_pair[1] != false
          $window.nid?("setVariable", key_value_pair[0], String(key_value_pair[1]))
      )

    # For NeuroID 3.x
    $scope.recordNeuroIdCheckpoint = (checkpoint) ->
      $window.nid?("setCheckpoint", checkpoint)

    if trackingEnabledOnPage()
      # For NeuroID 3.x
      $window.nid?("start", $scope.page)
      $window.nid?("setUserId", $scope.customer_application.uuid);

    if shouldSubmitMetadataOnThisPage()
      CustomerApplicationService.getNeuroIdMetadata().then((response) ->
        data_to_submit = presentNeuroIdCustomAttributes(response.data)
        # For NeuroID 2.x
        $scope.neuroIdTrackingPage.setCustomAttributes(data_to_submit)
        # For NeuroID 3.x
        submitMetadata(data_to_submit)
      )

    $scope.$on 'customer_application:submit', (event, page) ->
      if page == "additional_information"
        $scope.recordNeuroIdCheckpoint("application_submitted")
]
